import { createQueryBuilderV4 } from "@odata2ts/odata-query-builder";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { odataFetch } from "../../lib/odata-fetch";
import {
  APPMain_GF_InsertScanDiagnostic2Params,
  APPMain_GF_InsertScanDiagnosticResponse,
} from "../../odata/appu4dm/AppU4DMModel";
import { QAPPMain_GF_InsertScanDiagnostic } from "../../odata/appu4dm/QAppU4DM";
import { useMachine } from "../machine/use-machine";

export function useInsertScanDiagnostic() {
  const { machine } = useMachine();
  const queryClient = useQueryClient();
  const { token } = queryClient.getDefaultOptions().queries?.meta ?? {};

  const { mutate, ...mutation } = useMutation({
    mutationFn: ({ type, mtu, timestamp }: Omit<Payload, "machineId">) =>
      postInsertScanDiagnostic(
        {
          machineId: machine!.EquipmentNId!,
          type,
          mtu,
          timestamp,
        },
        token!
      ),
  });

  return {
    sendInsertScanDiagnostic: mutate,
    ...mutation,
  };
}

type Payload = {
  machineId: string;
  type:
    | "Received_OnStartWorkOrderOperationSerialized"
    | "Received_OnCompleteWorkOrderOperationSerialized";
  mtu: string;
  timestamp: Date;
};

async function postInsertScanDiagnostic(payload: Payload, token: string) {
  const builder = createQueryBuilderV4(
    "APPMain_GF_InsertScanDiagnostic",
    new QAPPMain_GF_InsertScanDiagnostic()
  );

  return odataFetch<
    APPMain_GF_InsertScanDiagnosticResponse,
    APPMain_GF_InsertScanDiagnostic2Params
  >({
    method: "POST",
    builder,
    token,
    body: {
      command: {
        SerialNumber: payload.mtu,
        Timestamp: payload.timestamp.toJSON(),
        Type: payload.type,
        WorkCenter: payload.machineId,
      },
    },
  });
}
